import { ReactNode } from "react";

function FullWidthContainer(props: {
  children?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={`relative left-1/2 right-1/2 -mx-[var(--viewportWidth50)] w-[var(--viewportWidth)] p-5 lg:p-20 ${
        props.className ?? ""
      }`}
    >
      {props.children}
    </div>
  );
}

export default FullWidthContainer;
